__turbopack_context__.v({
  "gradientOverlay": "ReviewsSection-module__7Gye_a__gradientOverlay",
  "reviewsBento": "ReviewsSection-module__7Gye_a__reviewsBento",
  "reviewsContainer": "ReviewsSection-module__7Gye_a__reviewsContainer",
  "reviewsHeader": "ReviewsSection-module__7Gye_a__reviewsHeader",
  "reviewsPlaceholder": "ReviewsSection-module__7Gye_a__reviewsPlaceholder",
  "reviewsTitle": "ReviewsSection-module__7Gye_a__reviewsTitle",
  "root": "ReviewsSection-module__7Gye_a__root",
  "viewAllButton": "ReviewsSection-module__7Gye_a__viewAllButton",
  "viewAllButtonMobile": "ReviewsSection-module__7Gye_a__viewAllButtonMobile",
  "viewAllDesktop": "ReviewsSection-module__7Gye_a__viewAllDesktop",
});
